import type { UseBasketDesignedUiCompatibleGmOrderDataResult } from './useBasketDesignedUiCompatibleGmOrderDat'
import type { UseExistingOrderItemsResult } from './useExistingOrderItems'
import type { UseExistingOrderMutationsResult } from './useExistingOrderMutations'
import type { UseExistingOrderQueriesResult } from './useExistingOrderQueries'
import type {
  UseExistingOrderValidationResult,
  ExistingOrderValidationErrors,
} from './useExistingOrderValidation'
import type { UseInputRelatedVariableOrderDataResult } from './useInputRelatedVariableOrderData'

export type ExistingOrderState = {
  orderData: UseExistingOrderQueriesResult['orderData']
  basketDesignedUiCompatibleOrderData: UseBasketDesignedUiCompatibleGmOrderDataResult['orderData']
  loadingOrderData: boolean
  orderItems: UseExistingOrderItemsResult['orderItems']
  orderItemsInternal: UseExistingOrderItemsResult['orderItemsInternal']
  removedOrderItems: UseExistingOrderItemsResult['removedOrderItems']
  changesMade: UseExistingOrderItemsResult['changesMade']
  itemQuantity: UseExistingOrderItemsResult['itemQuantity']
  newItemWasJustAdded: UseExistingOrderItemsResult['newItemWasJustAdded']
  adjustItemQuantity: UseExistingOrderItemsResult['adjustItemQuantity']
  addNewItemToOrder: UseExistingOrderItemsResult['addNewItemToOrder']
  removeItemFromOrder: UseExistingOrderItemsResult['removeItemFromOrder']
  fees: UseInputRelatedVariableOrderDataResult['fees']
  taxRateTotals: UseInputRelatedVariableOrderDataResult['taxRateTotals']
  grandTotals: UseInputRelatedVariableOrderDataResult['grandTotals']
  subtotalExTaxAsNumber: UseInputRelatedVariableOrderDataResult['subtotalExTaxAsNumber']
  totalIncTaxAsNumber: UseInputRelatedVariableOrderDataResult['totalIncTaxAsNumber']
  recalculatingFees: UseInputRelatedVariableOrderDataResult['recalculatingFees']
  recalculatingTotals: UseInputRelatedVariableOrderDataResult['recalculatingTotals']
  minimumOrderValue: UseInputRelatedVariableOrderDataResult['minimumOrderValue']
  userEditCutOffTime: UseInputRelatedVariableOrderDataResult['userEditCutOffTime']
  canSaveChanges: UseExistingOrderValidationResult['canSaveChanges']
  validationErrors: ExistingOrderValidationErrors
  saving: UseExistingOrderMutationsResult['saving']
  saveError: UseExistingOrderMutationsResult['saveError']
  saveOrderChanges: UseExistingOrderMutationsResult['saveOrderChanges']
  orderDataCalled: UseExistingOrderQueriesResult['called']
  orderLoadFailed: UseExistingOrderQueriesResult['loadFailed']
}

const noopAdjustItemQuantity: ExistingOrderState['adjustItemQuantity'] = () => {}
const noopAddNewItemToOrder: ExistingOrderState['addNewItemToOrder'] = () => {}
const noopRemoveItemFromOrder: ExistingOrderState['removeItemFromOrder'] = () => {}
const noopSaveOrderChanges: ExistingOrderState['saveOrderChanges'] = async () => {}

export const emptyExistingOrderState: ExistingOrderState = {
  orderData: null,
  basketDesignedUiCompatibleOrderData: null,
  loadingOrderData: false,
  orderItems: [],
  orderItemsInternal: [],
  removedOrderItems: [],
  changesMade: false,
  itemQuantity: 0,
  newItemWasJustAdded: false,
  adjustItemQuantity: noopAdjustItemQuantity,
  addNewItemToOrder: noopAddNewItemToOrder,
  removeItemFromOrder: noopRemoveItemFromOrder,
  fees: [],
  taxRateTotals: [],
  grandTotals: { subtotalExTax: '', totalIncTax: '', totalTax: '' },
  subtotalExTaxAsNumber: 0,
  totalIncTaxAsNumber: 0,
  recalculatingFees: false,
  recalculatingTotals: false,
  minimumOrderValue: 0,
  userEditCutOffTime: null,
  canSaveChanges: false,
  validationErrors: {},
  saving: false,
  saveError: undefined,
  saveOrderChanges: noopSaveOrderChanges,
  orderDataCalled: false,
  orderLoadFailed: false,
}
